import {
  matchRoute,
  MatchRouteResponse,
  BaseApiRequest,
  ListRoutesResponse,
  listRoutes,
  getRoute,
  upsertRoute,
  isSlugDuplicate,
  SlugDuplicateResponse,
  IsSlugDuplicateParams,
} from "@robe/core-api";
import { UpsertRoute } from "@robe/core-types";
import { XcoreCore } from ".";
import { Route } from "../types";

export class XcoreRouting {
  private core: XcoreCore;

  public constructor(core: XcoreCore) {
    this.core = core;
  }

  /**
   * Matches route to the routes available in DB.
   * If locale uses routing of different locale than that's the locale that will be used to match route, otherwise current locale is used.
   * If route doesn't exist for previous routing locale or current locale but it has fallback routing locale, BE tries to use that.
   *
   * @param urlOrRoute Request url or route without the trailing slash.
   */
  public match(urlOrRoute: string): BaseApiRequest<MatchRouteResponse> {
    if (!urlOrRoute.startsWith("/")) {
      return matchRoute(new URL(urlOrRoute).pathname, this.core);
    }

    return matchRoute(urlOrRoute, this.core);
  }

  public isSlugDuplicate(params: IsSlugDuplicateParams): BaseApiRequest<SlugDuplicateResponse[]> {
    return isSlugDuplicate(this.core, params);
  }

  public listRoutes(): BaseApiRequest<ListRoutesResponse> {
    return listRoutes(this.core);
  }

  public getRoute(routeId: string | number): BaseApiRequest<Route> {
    return getRoute(routeId, this.core);
  }

  public upsertRoute(route: UpsertRoute | Route) {
    const { method, ...rest } = route;
    return upsertRoute(rest, method, this.core);
  }
}
